import { AccordionSummary, Paper, Typography } from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';

interface StyledAccordionSummaryProps {
  bgColor: string;
  textColor: string;
}

export const StyledAccordionSummary = styled(AccordionSummary)<
  StyledAccordionSummaryProps
>`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  .request-icon {
    width: 25px;
    height: 19px;
  }
`;

export const StyledTypography = styled(Typography)`
  text-transform: uppercase;
  font-weight: bold;
`;

export const StyledPaper = styled(Paper)`
  width: 200px;
  padding: 16px;
  margin: 8px 8px 8px 0px;
`;

export const StyledTitleTypography = styled(Typography)`
  font-size: 15px;
  color: ${COLORS.ACCORDION_GRAY};
`;

export const StyledFlex = styled.div`
  display: flex;
`;
